
import { Component, Input } from '@angular/core';
import { PolicyBeneficiaryDto, PolicyDto } from '../../../../../service/dto-insurance';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { DependantDto, DynamicFormDto } from '../../../../../service/dto';
import { FormResult } from '../../../../../components/dynamic-form/dynamic-form.component';
import { HttpDependantService } from '../../../../../service/http-dependant.service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-policy-beneficiary-modal',
  standalone: false,
  templateUrl: './policy-beneficiary-modal.component.html',
  styleUrl: './policy-beneficiary-modal.component.scss'
})
export class PolicyBeneficiaryModalComponent {
	@Input() policy!: PolicyDto;
	@Input() beneficiary?: PolicyBeneficiaryDto;
	data?: DynamicFormDto;

	constructor(private modalRef: NzModalRef, private httpService: HttpDependantService) {
		this.policy = this.modalRef.getConfig().nzData.policy;
		this.beneficiary = this.modalRef.getConfig().nzData.beneficiary;
	}

	ngOnInit() {
		if (this.beneficiary) {
			this.httpService.get(+this.beneficiary.id!).subscribe(result => {
				this.data = result;
			});
		} else {
			this.httpService.getForm().subscribe(result => {
				this.data = result;
			});
		}
	}


	doHandleResult(input: FormResult) {
		if (input.type == 'Cancel') {
			this.modalRef.close(null);
			return;
		}
		if (this.beneficiary) {
			this.httpService.edit(this.beneficiary.id!, input.data)
				.pipe(switchMap(result => this.httpService.getEntity(result.id!)))
				.subscribe(result => {
					this.modalRef.close(result);
				});
		} else {
			this.httpService.createForPolicy(this.policy, input.data)
				.pipe(switchMap(result => this.httpService.getEntity(result.id!)))
				.subscribe(result => {
					this.modalRef.close(result);
				});
		}
	}
	remove() {
		this.modalRef.close(undefined);
	}
	cancel() {
		this.modalRef.close(undefined);
	}
}
